<template>
  <div class="q-content">
    <StartPage v-if="curIndex == -1" @next="bindNext" />
    <div
      v-if="curIndex > 0 && !disabledPre"
      @click.stop="bindPre"
      class="pre-question"
      :class="{ 'app-pre-question': isApp }"
      ><span class="iconfont icon-xiala"></span>上一题</div
    >
    <QuestionIndex1
      v-if="curIndex == 0"
      @next="bindNext"
      @pre="bindPre"
      :index="0"
      :data="questionData"
    ></QuestionIndex1>
    <QuestionIndex2
      v-if="curIndex == 1"
      @next="bindNext"
      @pre="bindPre"
      :index="1"
      :data="questionData"
    ></QuestionIndex2>
    <QuestionIndex3
      v-if="curIndex == 2"
      @next="bindNext"
      @pre="bindPre"
      :index="2"
      :data="questionData"
    ></QuestionIndex3>
    <QuestionIndex4
      v-if="curIndex == 3"
      @next="bindNext"
      @pre="bindPre"
      :index="3"
      :data="questionData"
    ></QuestionIndex4>
    <QuestionIndex5
      v-if="curIndex == 4"
      @next="bindNext"
      @pre="bindPre"
      :index="4"
      :data="questionData"
    ></QuestionIndex5>
    <QuestionIndex6
      v-if="curIndex == 5"
      @next="bindNext"
      @pre="bindPre"
      :index="5"
      :data="questionData"
    ></QuestionIndex6>
    <QuestionIndex7
      v-if="curIndex == 6"
      @next="bindNext"
      @pre="bindPre"
      :index="6"
      :data="questionData"
    ></QuestionIndex7>
    <QuestionIndex8
      v-if="curIndex == 7"
      @next="bindNext"
      @pre="bindPre"
      :index="7"
      :data="questionData"
    ></QuestionIndex8>
    <QuestionIndex9
      v-if="curIndex == 8"
      @next="bindNext"
      @pre="bindPre"
      :index="8"
      :data="questionData"
    ></QuestionIndex9>
    <QuestionIndex10
      v-if="curIndex == 9"
      @next="bindNext"
      @pre="bindPre"
      :index="9"
      :data="questionData"
    ></QuestionIndex10>
    <QuestionIndex11
      v-if="curIndex == 10"
      @next="bindNext"
      @pre="bindPre"
      :index="10"
      :data="questionData"
    ></QuestionIndex11>
    <QuestionIndex12
      v-if="curIndex == 11"
      @next="bindNext"
      @pre="bindPre"
      :index="11"
      :data="questionData"
    ></QuestionIndex12>
    <QuestionIndex13
      v-if="curIndex == 12"
      @next="bindNext"
      @pre="bindPre"
      :index="12"
      :data="questionData"
    ></QuestionIndex13>
    <QuestionIndex14
      v-if="curIndex == 13"
      @next="bindNext"
      @pre="bindPre"
      :index="13"
      :data="questionData"
    ></QuestionIndex14>
  </div>
</template>
<script>
import StartPage from './components/start.vue'
import QuestionIndex1 from './components/question/q1.vue'
import QuestionIndex2 from './components/question/q2.vue'
import QuestionIndex3 from './components/question/q3.vue'
import QuestionIndex4 from './components/question/q4.vue'
import QuestionIndex5 from './components/question/q5.vue'
import QuestionIndex6 from './components/question/q6.vue'
import QuestionIndex7 from './components/question/q7.vue'
import QuestionIndex8 from './components/question/q8.vue'
import QuestionIndex9 from './components/question/q9.vue'
import QuestionIndex10 from './components/question/q10.vue'
import QuestionIndex11 from './components/question/q11.vue'
import QuestionIndex12 from './components/question/q12.vue'
import QuestionIndex13 from './components/question/q13.vue'
import QuestionIndex14 from './components/question/q14.vue'
import { questionData } from './data.js'
export default {
  components: {
    StartPage,
    QuestionIndex1,
    QuestionIndex2,
    QuestionIndex3,
    QuestionIndex4,
    QuestionIndex5,
    QuestionIndex6,
    QuestionIndex7,
    QuestionIndex8,
    QuestionIndex9,
    QuestionIndex10,
    QuestionIndex11,
    QuestionIndex12,
    QuestionIndex13,
    QuestionIndex14
  },
  data() {
    return {
      isApp: false,
      curIndex: -1,
      questionData,
      disabledPre: false,
      loaded: false
    }
  },
  created() {
    this.isApp = this.$http._isApp()
  },
  mounted() {},
  methods: {
    //保存问卷
    saveQuestionData() {
      let params = {
        type: 9,
        info: JSON.stringify(this.questionData),
        rid: this.$route.query.rid || ''
      }
      this.$http
        .postBaseApp('member/AppCamp/posterQuestionSave', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.$router.push({
              path: '/newcomer-questionnaire/result',
              query: {
                rid: this.$route.query.rid || ''
              }
            })
          } else {
            this.$toast(res.msg)
          }
        })
    },
    bindNext() {
      if (this.curIndex >= 13) {
        this.saveQuestionData()
        return
      }
      if (this.curIndex < this.questionData.length - 1) {
        this.curIndex++
      }
    },
    bindPre() {
      if (this.disabledPre) {
        return
      }
      this.disabledPre = true
      this.curIndex--
      if (this.curIndex < -1) {
        this.curIndex = -1
      }
      setTimeout(() => {
        this.disabledPre = false
      }, 600)
    }
  }
}
</script>
<style lang="scss" scoped>
.q-content {
  width: 100%;
  height: 100vh;
  position: relative;
  .pre-question {
    position: absolute;
    top: 22px;
    left: 20px;
    z-index: 99;
    height: 27px;
    padding: 4px 12px 4px 4px;
    box-sizing: border-box;
    background: #000000;
    border-radius: 14px;
    opacity: 0.9;
    font-size: 13px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 18px;
    display: flex;
    align-items: center;
    .iconfont {
      display: inline-block;
      transform: rotate(90deg);
      color: #fff;
    }
  }
  .app-pre-question {
    top: 102px;
  }
  .close {
    padding: 10px;
    font-size: 24px;
    color: rgba(0, 0, 0, 0.8);
    font-weight: 600;
    position: absolute;
    left: 24px;
    top: 45px;
    z-index: 99;
  }
}
</style>
